import React, { Component } from 'react'

import PropTypes from 'prop-types'

import Slider from 'react-slick'

export default class SampleActivity extends Component {
  static propTypes = {
    images: PropTypes.array,
    heading: PropTypes.string,
    text: PropTypes.string
  }

  sliderSettings = {
    dots: true,
    infinite: false
  }

  render() {
    return (
      <div className="activity">
        <div className="slider-wrapper">
          <Slider {...this.sliderSettings}>
            {this.props.images.map((url, index) => {
              return (
                <div
                  key={index}
                  className="slide"
                  style={{
                    backgroundImage: `url(${url})`,
                    backgroundRepeat: 'no-repeat'
                  }}
                >
                  {' '}
                </div>
              )
            })}
          </Slider>
        </div>
        <div className="activity__card">
          <h2 className="activity__heading">{this.props.heading}</h2>
          <p className="activity__description">{this.props.text}</p>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// src/components/ActivityList/SampleActivity.js